import { Injectable, Injector } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { BaseCrudService } from '../base-crud.service';
import { ConfigModel } from '../../models/geral/config-model';

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends BaseCrudService<ConfigModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'ConfigTenant';
  }

  getConfigByGrupoChave(grupo: string, chave: string): Observable<ConfigModel> {
    return this
      .httpClient
      .get<ConfigModel>(`${this.getApiUrl()}${this.getController()}/GetConfigByGrupoChave/${grupo}/${chave}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  getModelByChave(chave: string): Observable<ConfigModel> {
    return this
      .httpClient
      .get<ConfigModel>(`${this.getApiUrl()}${this.getController()}/GetModelByChave/${chave}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
